import loadImage from "blueimp-load-image";

export const dataUrlToBlob = dataUrl => {
  const byteString = atob(dataUrl.split(",")[1]);
  const mimeType = dataUrl.match(/(:)([a-z/]+)(;)/)[2];
  const l = byteString.length;
  const content = new Uint8Array(l);
  for (let i = 0; l > i; i++) {
    content[i] = byteString.charCodeAt(i);
  }
  return new Blob([content], { type: mimeType });
};

export const loadImageWithOrientationCorrection = (
  fileOrBlobOrUrl,
  additionalOptions = null
) => {
  return new Promise(resolve => {
    // EIXF情報にOrientationがある場合、正位置になるよう回転させるため、Orientation情報を取得する
    const options = {};
    options.meta = true;
    loadImage(
      fileOrBlobOrUrl,
      (img, data) => {
        if (data.exif && data.exif.get("Orientation")) {
          options.orientation = data.exif.get("Orientation");
        }

        // 取得したOrientation情報を反映して元の回転した画像(imageUrl)を正位置画像(canvas.toDataURL)として使用する
        Object.assign(options, additionalOptions);
        options.canvas = true;
        loadImage(fileOrBlobOrUrl, canvas => resolve(canvas), options);
      },
      options
    );
  });
};
